import { css } from 'emotion';

export const inputStyle = css`
  & input {
    cursor: pointer;
  }

  label: input;
`;
